export const ScrollKeys = Object.freeze({
  SCROLLED_OFFSET: 'scrolledOffset',
  IS_SCROLLED: 'isScrolled',
  IS_NOWPLAYING_TOP_IN_VIEW: 'isNowPlayingTopInView',
} as const);

export const ScrollThresholds = Object.freeze({
  SCROLL_THROTTLE: 100, // milliseconds between new scroll position actions fired
  SCROLL_FROM_TOP_BUFFER: 30,
  NOWPLAYING_TOP_HEIGHT: 500,
} as const);
